export var ItemFilter;
(function (ItemFilter) {
    ItemFilter["All"] = "All";
    ItemFilter["MyWallet"] = "MyWallet";
    ItemFilter["Listed"] = "Listed";
    ItemFilter["Draft"] = "Draft";
    ItemFilter["Minted"] = "Minted";
    ItemFilter["Favorites"] = "Favorites";
})(ItemFilter || (ItemFilter = {}));
export var DraftStatus;
(function (DraftStatus) {
    DraftStatus["Generated"] = "GENERATED";
    DraftStatus["Minted"] = "MINTED";
})(DraftStatus || (DraftStatus = {}));
export var EVMChain;
(function (EVMChain) {
    EVMChain[EVMChain["Avalanche"] = 0] = "Avalanche";
    EVMChain[EVMChain["Ethereum"] = 1] = "Ethereum";
    EVMChain[EVMChain["BinanceSmartChain"] = 2] = "BinanceSmartChain";
    EVMChain[EVMChain["Localhost"] = 3] = "Localhost";
    EVMChain[EVMChain["ImmutableX"] = 4] = "ImmutableX";
    EVMChain[EVMChain["Monad"] = 5] = "Monad";
    EVMChain[EVMChain["ApeChain"] = 6] = "ApeChain";
    EVMChain[EVMChain["Beam"] = 7] = "Beam";
})(EVMChain || (EVMChain = {}));
export var SVMChain;
(function (SVMChain) {
    SVMChain[SVMChain["Solana"] = 0] = "Solana";
})(SVMChain || (SVMChain = {}));
export const NFT_NAME = 'CryptoVerse-AI';
export const NFT_SYMBOL = 'CVS';
export const shortenAddress = (address) => {
    if (!address)
        return '';
    const str = address.toString();
    if (str.startsWith('0x'))
        return `${str.slice(0, 6)}...${str.slice(-4)}`;
    else
        return `${str.slice(0, 4)}...${str.slice(-4)}`;
};
export const subAddress = (address) => {
    if (!address)
        return '';
    const str = address.toString();
    if (str.startsWith('0x'))
        return `${str.slice(0, 6)}`;
    else
        return `${str.slice(0, 4)}`;
};
export const getFastestRpc = async (rpcs, callback) => {
    let fastestRpc = null;
    if (typeof rpcs == 'string') {
        fastestRpc = await callback(rpcs)
            .then(() => rpcs)
            .catch(() => null);
    }
    else {
        fastestRpc = await Promise.any(rpcs.map(async (rpc) => {
            await callback(rpc);
            return rpc;
        }))
            .then((rpc) => rpc)
            .catch((_e) => null);
    }
    return fastestRpc;
};
